import LineFilters from '../../generic/LineFilters';
import convertToOption from '../../utils/convert-to-option';
import getEventTargetValue from '../../utils/get-event-target-value';
import { applyFilters } from '../actions';
import { connectEditor } from '../connect-editor';
import {
  CAMPAIGN_FILTER_TYPES,
  getAvailableFilterValues,
  getCategoryOptions,
} from '../utils/filter-utils';

const mapStateToProps = (
  { campaignLinesById, campaignLineFilters },
  { allCategories },
) => {
  const filterOptions = getAvailableFilterValues(campaignLinesById);
  return {
    filters: CAMPAIGN_FILTER_TYPES.map(({ name }) => ({
      name,
      selected: campaignLineFilters[name],
      all:
        name === 'categories'
          ? getCategoryOptions(filterOptions[name], allCategories)
          : filterOptions[name].map(convertToOption),
    })),
  };
};

const mapDispatchToProps = dispatch => ({
  onChange: event =>
    dispatch(
      applyFilters(event.target.name, getEventTargetValue(event.target)),
    ),
});

const ConnectedCampaignLineFilters = connectEditor(
  mapStateToProps,
  mapDispatchToProps,
)(LineFilters);
export default ConnectedCampaignLineFilters;
